var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMonitorCanvas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.751 79.7078H94.7322V61.7266H88.7697V73.7453H76.751V79.7078ZM26.2697 49.2266H32.2322V37.2078H44.251V31.2453H26.2697V49.2266ZM43.001 102.977V92.9766H22.0397C19.5139 92.9766 17.376 92.1016 15.626 90.3516C13.876 88.6016 13.001 86.4636 13.001 83.9378V27.0153C13.001 24.4895 13.876 22.3516 15.626 20.6016C17.376 18.8516 19.5139 17.9766 22.0397 17.9766H98.9622C101.488 17.9766 103.626 18.8516 105.376 20.6016C107.126 22.3516 108.001 24.4895 108.001 27.0153V83.9378C108.001 86.4636 107.126 88.6016 105.376 90.3516C103.626 92.1016 101.488 92.9766 98.9622 92.9766H78.001V102.977H43.001ZM22.0397 85.4766H98.9622C99.3472 85.4766 99.6997 85.3161 100.02 84.9953C100.341 84.6753 100.501 84.3228 100.501 83.9378V27.0153C100.501 26.6303 100.341 26.2778 100.02 25.9578C99.6997 25.637 99.3472 25.4766 98.9622 25.4766H22.0397C21.6547 25.4766 21.3022 25.637 20.9822 25.9578C20.6614 26.2778 20.501 26.6303 20.501 27.0153V83.9378C20.501 84.3228 20.6614 84.6753 20.9822 84.9953C21.3022 85.3161 21.6547 85.4766 22.0397 85.4766Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMonitorCanvas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-monitor-canvas.44354b03c7436ca68acac1d7b1030d02.svg";